/**
 * Pricing & Plans Query Hooks
 * Handles pricing configuration and available plans
 */

import { useQuery } from '@tanstack/react-query';
import api from '../../utils/api.js';
import { queryKeys } from '../../lib/queryKeys.js';

/**
 * Get pricing configuration (single source of truth)
 * Long cache time - pricing rarely changes
 */
export function usePricing(options = {}) {
    return useQuery({
        queryKey: queryKeys.pricing,
        queryFn: async () => {
            const response = await api.getPricing();
            return response;
        },
        staleTime: 60 * 60 * 1000, // 1 hour
        gcTime: 2 * 60 * 60 * 1000, // 2 hours cache
        ...options,
    });
}

/**
 * Get available subscription plans
 */
export function useAvailablePlans(options = {}) {
    return useQuery({
        queryKey: queryKeys.availablePlans,
        queryFn: async () => {
            const response = await api.getAvailablePlans();
            return response;
        },
        staleTime: 60 * 60 * 1000, // 1 hour
        gcTime: 2 * 60 * 60 * 1000, // 2 hours cache
        ...options,
    });
}

export default {
    usePricing,
    useAvailablePlans,
};
